import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  Dropdown,
  Input,
  Button,
  Checkbox
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardMedCertificateReportUX = (props: any) => {
    return(
      <div
        style={{position: "relative", padding: "1em"}}>
        {props.onLoading}
        <div
          id="CardMedCertificateReportUX-div-57"
          style={{fontWeight: "bold", fontSize: "large"}}>
          {props.languageUX === "en" ? "Medical certificate" : "ใบรับรองแพทย์"}
        </div>
        <hr
          id="CardMedCertificateReportUX-hr-58">
        </hr>
        <div
          id="CardMedCertificateReportUX-div-59"
          style={{display: "flex"}}>
          
          <div
            id="CardMedCertificateReportUX-div-60"
            style={{flex: "1"}}>
            
            <Form
              id="CardMedCertificateReportUX-Form-62">
              <FormGroup
                className="ui form"
                id="CardMedCertificateReportUX-FormGroup-67"
                style={{padding: "1em 0em 0em 0.5em", gap: "2em"}}>
                <label
                  id="CardMedCertificateReportUX-label-68"
                  style={{display: "flex", alignItems: "center", fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Document type" : "ประเภทเอกสาร"}
                </label>
                <Dropdown
                  clearable={true}
                  disabled={props.disabledReportOption || false}
                  id="CardMedCertificateReport-Dropdown-ReportType"
                  onChange={props.onHandleReport}
                  options={props.reportOption}
                  placeholder="เลือกประเภทเอกสาร"
                  search={true}
                  selection={true}
                  style={{width: "22em"}}
                  value={props.onReportValue}>
                </Dropdown>
              </FormGroup>
            </Form>
            <div
              id="CardMedCertificateReportUX-div-63">
              {props.reportTypeSelect}
            </div>
            <div
              id="CardMedCertificateReportUX-div-94">
              {props.onSaveReport}
            </div>
          </div>
          <div
            id="CardMedCertificateReportUX-div-61"
            style={{flex: "1"}}>
            
            <Form
              id="CardMedCertificateReportUX-Form-64">
              <FormGroup
                className="ui form"
                id="CardMedCertificateReportUX-FormGroup-65"
                style={{padding: "1em 0em 0em 0em", justifyContent: "flex-end", gap: "1em"}}>
                <label
                  id="CardMedCertificateReportUX-label-76"
                  style={{display: "flex", alignItems: "center", fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "From" : "จาก"}
                </label>
                <DateTextBox
                  id="CardMedCertificateReportUX-DateTextBox-80"
                  onChange={(date: string) => props.onHandleDateNew("startDate", date)}
                  value={props.startDate}>
                </DateTextBox>
                <label
                  id="CardMedCertificateReportUX-label-77"
                  style={{display: "flex", alignItems: "center", fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "To" : "ถึง"}
                </label>
                <DateTextBox
                  id="CardMedCertificateReportUX-DateTextBox-81"
                  onChange={(date: string) => props.onHandleDateNew("endDate", date)}
                  value={props.endDate}>
                </DateTextBox>
              </FormGroup>
              <FormGroup
                className="ui form"
                id="CardMedCertificateReportUX-FormGroup-66"
                style={{padding: "0em 0em 2em 0em", justifyContent: "flex-end", gap: "1em"}}>
                <Checkbox
                  checked={props.checkAllDoctor}
                  id="CardMedCertificateReportUX-Checkbox-97"
                  label={props.languageUX === "en" ? "All medical certificates" : "ใบรับรองแพทย์ทั้งหมด"}
                  onChange={props.onCheckAllDoctor}
                  style={{display: "flex", alignItems: "center", fontWeight: "bold"}}>
                </Checkbox>
                <label
                  id="CardMedCertificateReportUX-label-82"
                  style={{display: "flex", alignItems: "center", fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "physician" : "แพทย์"}
                </label>
                <Input
                  icon="search"
                  id="CardMedCertificateReport-Input-SearchDoctor"
                  onChange={(e) => props.onHandleDoctorName("doctorName", e)}
                  placeholder="เว้นว่างเพื่อหาทุกแพทย์"
                  value={props.onDoctorName}>
                </Input>
                <Button
                  color="blue"
                  id="CardMedCertificateReportUX-Button-84"
                  loading={props.searchReportLoading}
                  onClick={props.onSearchReport}>
                  {props.languageUX === "en" ? "Search" : "ค้นหา"}
                </Button>
              </FormGroup>
            </Form>
            <Table
              data={props.dataTable}
              getTrProps={props.rowProps}
              headers={`วันที่-เวลาที่พิมพ์,รหัส,ประเภทเอกสาร,ภาษา,ผู้พิมพ์,สำเนา`}
              id="CardMedCertificateReportUX-Table-85"
              keys={props.keyTable}
              minRows="10"
              showPagination={false}
              style={{ height: "400px", }}
              widths="150, 80, 130,50, auto,70">
            </Table>
            <div
              id="CardMedCertificateReportUX-div-96">
              {props.onDuplicateReport}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardMedCertificateReportUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 11:59:07 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.onLoading"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", padding: \"1em\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ใบรับรองแพทย์",
          "valueEN": "Medical certificate"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"large\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "hr",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-hr-58"
        }
      },
      "seq": 58,
      "void": true
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{flex: \"1\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{flex: \"1\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Form",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-Form-62"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.reportTypeSelect"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-div-63"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Form",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-Form-64"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormGroup",
      "parent": 64,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-FormGroup-65"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1em 0em 0em 0em\", justifyContent: \"flex-end\", gap: \"1em\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormGroup",
      "parent": 64,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-FormGroup-66"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0em 0em 2em 0em\", justifyContent: \"flex-end\", gap: \"1em\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormGroup",
      "parent": 62,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-FormGroup-67"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1em 0em 0em 0.5em\", gap: \"2em\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทเอกสาร",
          "valueEN": "Document type"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-label-68"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", fontWeight: \"bold\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Dropdown",
      "parent": 67,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledReportOption || false"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReport-Dropdown-ReportType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onHandleReport"
        },
        "options": {
          "type": "code",
          "value": "props.reportOption"
        },
        "placeholder": {
          "type": "value",
          "value": "เลือกประเภทเอกสาร"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"22em\"}"
        },
        "value": {
          "type": "code",
          "value": "props.onReportValue"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "จาก",
          "valueEN": "From"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-label-76"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", fontWeight: \"bold\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "To"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-label-77"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", fontWeight: \"bold\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 80,
      "name": "DateTextBox",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-DateTextBox-80"
        },
        "onChange": {
          "type": "code",
          "value": "(date: string) => props.onHandleDateNew(\"startDate\", date)"
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 81,
      "name": "DateTextBox",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-DateTextBox-81"
        },
        "onChange": {
          "type": "code",
          "value": "(date: string) => props.onHandleDateNew(\"endDate\", date)"
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "physician"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-label-82"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", fontWeight: \"bold\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "Input",
      "parent": 66,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReport-Input-SearchDoctor"
        },
        "onChange": {
          "type": "code",
          "value": "(e) => props.onHandleDoctorName(\"doctorName\", e)"
        },
        "placeholder": {
          "type": "value",
          "value": "เว้นว่างเพื่อหาทุกแพทย์"
        },
        "value": {
          "type": "code",
          "value": "props.onDoctorName"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Button",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-Button-84"
        },
        "loading": {
          "type": "code",
          "value": "props.searchReportLoading"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearchReport"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 85,
      "name": "Table",
      "parent": 61,
      "props": {
        "data": {
          "type": "code",
          "value": "props.dataTable"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.rowProps"
        },
        "headers": {
          "type": "code",
          "value": "`วันที่-เวลาที่พิมพ์,รหัส,ประเภทเอกสาร,ภาษา,ผู้พิมพ์,สำเนา`"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-Table-85"
        },
        "keys": {
          "type": "code",
          "value": "props.keyTable"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"400px\", }"
        },
        "widths": {
          "type": "value",
          "value": "150, 80, 130,50, auto,70"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.onSaveReport"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-div-94"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "code",
          "value": "props.onDuplicateReport"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-div-96"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "Checkbox",
      "parent": 66,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkAllDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardMedCertificateReportUX-Checkbox-97"
        },
        "label": {
          "type": "value",
          "value": "ใบรับรองแพทย์ทั้งหมด",
          "valueEN": "All medical certificates"
        },
        "onChange": {
          "type": "code",
          "value": "props.onCheckAllDoctor"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", fontWeight: \"bold\"}"
        }
      },
      "seq": 82,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardMedCertificateReportUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
